import { Box, Flex, Text } from "@chakra-ui/react";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useSearchParams } from "react-router-dom";
import React from "react";
import { setGlobal } from "../../../../../context/global";

const AuditRequirementCard = ({ toReview, email }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const number = toReview?.length || 0;

  const setFilterBy = (value) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("rtab", 1);
    newParams.set("q", value);
    setSearchParams(newParams);
  };

  const gotoFilteredQuestionList = (questionIds, label = "Audit Requirements to Review") => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("rtab", 1); // HACK: goes to the DataInputPage to show the filtered list
    // HACK: pass the list of question ids to the DataInputPage via a global variable, as it may be too large for a url-param
    setGlobal("questionIdsFilter", { label, ids: questionIds });
    newParams.set("q", "questionIdsFilter:true");
    setSearchParams(newParams);
  };

  return (
    <>
      {/*<Text color="whiteShade.500" fontSize="heading.s" fontWeight="700">*/}
      {/*  Your tasks*/}
      {/*</Text>*/}
      <Box
        bg="lime"
        borderRadius="lg"
        // boxShadow="lg"
        borderColor="gray.200"
        p={6}
        minW="fit-content"
        width="400px"
        // width="100%"
        display="flex"
        flexDirection="column"
        color="darkTeal"
        _hover={{ cursor: "pointer" }}
        onClick={() => gotoFilteredQuestionList(Array.from(toReview), "Audit Requirements to Review")}
      >
        {/* Header - Left Aligned */}
        <Box textAlign="left">
          <Text fontSize="heading.m" fontWeight="bold">
            Requirements to review
          </Text>
          <Text fontSize="body.s" opacity={0.8} mt={1}>
            You need to review these requirements
          </Text>
        </Box>

        {/* Centered Numbers Section */}
        <Flex mt={8}>
          <Flex align="center">
            <Text fontSize="heading.4xl" fontWeight="bold">
              {number}
            </Text>
            <ArrowUpRight size={32} />
          </Flex>
        </Flex>
      </Box>
    </>
  );
};

export default AuditRequirementCard;
